import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DialogComponent, PageService, Shell, Transfer, NamedDialog, AppConfig } from '@tytapp/common';
import { Show, User } from '@tytapp/models';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@tytapp/user';
import { Observable } from 'rxjs';
import { ShowsApi } from 'api';
import { environment } from 'environment';

@NamedDialog('podcast')
@Component({
  selector: 'app-podcast',
  templateUrl: './podcast.component.html',
  styleUrls: ['./podcast.component.scss']
})
export class PodcastComponent extends DialogComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private userService : UserService,
    private showApi : ShowsApi,
    private appConfig : AppConfig,
    pageService : PageService
  ) {
    super(pageService);
  }

  get pageComponentId() {
    return 'podcast-dialog';
  }

  async init(params) {

    // iOS somehow ends up with the dialog component reloading 
    // when the user hits the back button. Problem is, we have 
    // no parameters available. For most cases it is appropriate to
    // just close the dialog.

    if (!params) {
      this.close();
      return;
    }
    
    this.subscribe(this.userService.userChanged, user => {
      this.user = user;
      this.updatePodcastUrl();
    });

    if (params) {
      this.updateParams(params);
    } else {
      this.subscribe(this.route.params, async params => {
        this.updateParams(params);
      });
    }
  }

  async updateParams(params) {
    if (this.hasServerState)
      return;
    
    if (params.id) {
      this.show = await this.showApi.get(params.id).toPromise() as Show;
    } else if (params.show) {
      this.show = params.show;
    }

    this.updatePodcastUrl();
  }

  get joinUrl() {
    return this.appConfig.purchaseUrl;
  }
  
  updatePodcastUrl() {
    if (!this.user || !this.show)
      return;
    
    this.podcastUrl = `${environment.platformUrl}/podcasts/premium/${this.user.uuid}/shows/${this.show.id}`;
    this.androidPodcastUrl = `https://subscribeonandroid.com/${this.podcastUrl.replace(/^https?:\/\//g, '')}`;

    // TODO: podcast URLs
  }

  @ViewChild('urlField')
  urlField : ElementRef;

  @Transfer()
  show : Show;

  @Transfer()
  user : User;

  @Transfer()
  podcastUrl : string;

  @Transfer()
  androidPodcastUrl : string;

  copyUrl() {
    if (typeof window === 'undefined')
      return;
    
    this.urlField.nativeElement.select();
    document.execCommand('copy');

    this.shell.showDialog('message', 
      'URL Copied',
      'The podcast URL has been copied to your clipboard. Paste it into your favorite podcasting application.'
    );
  }
}
